module.exports = __webpack_public_path__ + "so.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/so.svg
// module id = 1068
// module chunks = 0